document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".scroll-to-form").forEach(btn => {
        btn.addEventListener("click", (e) => {
        e.preventDefault(); // stops link jumping (optional)

        const target = document.querySelector(".copy-section"); // CHANGE THIS TO YOUR TARGET CLASS
        
        if (target) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
        });
    });

});


const modalOverlay = document.getElementById('modalOverlay');

function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}

// Close modal when clicking outside
modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
        closeModal();
    }
});

// Close modal on ESC key
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
        closeModal();
    }
});


$( document ).ready(function() {

    // schedule form
    document.getElementById('downloadForm').addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(this);
        const responseDiv = document.getElementById('response');
        
        // Show loading state
        responseDiv.innerHTML = 'Processing...';
        
        fetch('https://www.onpoint-us.com/onsite-health-and-safety/constant-contact-handler-ebook.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                //responseDiv.innerHTML = '<p style="color: green;">' + data.message + '</p>';
                document.getElementById('downloadForm').reset();
                document.querySelector('.grey-bg').classList.add('success');
                document.querySelector('.section4').classList.add('d-block');
                document.querySelector('.grey-bg').scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                responseDiv.innerHTML = '<p style="color: red;">Error: ' + data.message + '</p>';
            }
        })
        .catch(error => {
            responseDiv.innerHTML = '<p style="color: red;">An error occurred. Please try again.</p>';
            console.error('Error:', error);
        });
    });

    document.getElementById('connecting-onpoint').addEventListener('submit', function(e) {
        e.preventDefault();

        //const responseDiv = document.getElementById('response');

        // Show loading state
        //responseDiv.innerHTML = 'Processing...';

        // Get the full name and split it
        const fullName = document.getElementById("fullName").value.trim();
        const nameParts = fullName.split(' ');
        const firstName = nameParts[0] || '';
        const lastName = nameParts.slice(1).join(' ') || '';

        // Prepare FormData for Constant Contact (with split name)
        const ccFormData = new FormData();
        ccFormData.append('first_name', firstName);
        ccFormData.append('last_name', lastName);
        ccFormData.append('email', document.getElementById("email_adr").value);
        ccFormData.append('company_name', document.getElementById("company").value);
        ccFormData.append('phone', document.getElementById("phone").value);

        grecaptcha.ready(function() {
            grecaptcha.execute('6LeZaSgsAAAAANv9ipG4EYhd_hFgftdpkvQ4VpCA', {action: 'submit'}).then(function(token) {

                // Prepare data for process-lp.php (with full name)
                const internalFormData = {
                    fname: fullName,
                    email: document.getElementById("email_adr").value,
                    company: document.getElementById("company").value,
                    phone: document.getElementById("phone").value,
                    message: document.getElementById("message").value,
                    ref: '/onsite-health-and-safety/',
                    recaptchaToken: token
                };

                fetch('https://www.onpoint-us.com/inc/process-lp.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(internalFormData)
                })
                .then(r => r.text())
                .then(text => {
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        console.error('Internal JSON parse error:', e);
                        return { success: false, message: 'Invalid response from server' };
                    }
                })
                .catch(err => {
                    console.error('Internal Fetch error:', err);
                    return { success: false, message: 'Network error' };
                })
                .then(internalData => {
                    if (internalData.success) {
                        document.getElementById('connecting-onpoint').reset();
                        document.querySelector('.modal-content .success-message').style.display = 'block';
                        document.querySelector('.modal-content .modal-inner').style.display = 'none';

                        setTimeout(function() {
                            closeModal();
                        }, 5000);
                    } else {
                        const errorMsg = internalData.message || 'Failed to submit form';
                        console.error('Form submission failed:', errorMsg);
                    }
                });
            });
        });
    });
});